import { parseAsString, UrlKeys, useQueryStates } from 'nuqs';

const parsers = {
  after: parseAsString,
  before: parseAsString,
};

const urlKeys: UrlKeys<typeof parsers> = {
  after: 'after',
  before: 'before',
};

export const PAGE_SIZE = 10;

type UsePaginationParamsOptions = {
  pageSize?: number;
  urlKeys?: typeof urlKeys;
};

export const usePaginationParams = (options: UsePaginationParamsOptions = {}) => {
  const { pageSize = PAGE_SIZE, urlKeys: customUrlKeys = {} } = options;

  const [{ after, before }, set] = useQueryStates(parsers, {
    urlKeys: {
      ...urlKeys,
      ...customUrlKeys,
    },
  });

  const pagination = {
    after,
    before,
    first: !before ? pageSize : null,
    last: before ? pageSize : null,
  };

  return [pagination, set] as const;
};

export type PaginationState = ReturnType<typeof usePaginationParams>[0];
export type SetPaginationStateAction = ReturnType<typeof usePaginationParams>[1];
